var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"observe",rawName:"v-observe"}],staticClass:"portraitImage",class:{ 'portraitImage--absolute': !_vm.isHigher }},[_c('PixiImage',{attrs:{"image":_vm.image,"filter":_vm.filter,"canAnimate":_vm.canAnimate,"sizes":_vm.sizes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }